import uuid from 'uuid/v4';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PieChart from '../common/Charts/PieChart';
import BarChart from '../common/Charts/BarChart';
import QuickReportFootNote from './QuickReportFootNotes';
import {
  getSegmentationContent,
  processData,
} from '../../util/QuickReportsUtils';
import * as messages from "../../messages/ReportsMessages";
import { MODULE_SEGMENTATION, MOBILE_WORLD, MOBILITY_ADOPTION } from '../../constants';

// const colors = ['#00b0d9', '#2dc0e8', '#53cff3', '#83e3ff', '#9fcee8', '#317296'];
const chartColor = [
  '#247BA0',
  '#F25F5C',
  '#FFE066',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

export default class Segmentation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'Pie',
      selectedDropdown: this.props.dropdown[0].value,
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
    };
  }

  componentDidMount() {
    this.props.handletitle(`${this.state.selectedDropdown} Segmentation`);
    // (option, subtype, combos)
    this.props.handleExportParams(
      undefined,
      this.state.selectedDropdown,
      undefined,
    );
    this.props.trackerFn({ subModule: MODULE_SEGMENTATION });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
    if (this.props.data !== nextProps.data) {
    this.setState({ selectedDropdown: nextProps.dropdown[0].value });
    }
  }

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  handleDropdownChange = e =>
    this.setState({ selectedDropdown: e.currentTarget.value }, () => {
      const newTitle = this.state.selectedDropdown.split('(');
      if (newTitle.length > 1) {
        const updatedTitle = `${newTitle[0]} Segmentation (${newTitle[1]}`;
        this.props.handletitle(updatedTitle);
      } else {
        this.props.handletitle(`${this.state.selectedDropdown} Segmentation`);
      }
      this.props.handleExportParams(
        undefined,
        this.state.selectedDropdown,
        undefined,
      );
    });

  getDropdownValues = dropdownValues => {
    return dropdownValues.map(item => ({
      key: item.key,
      dataKey: item.value,
    }));
  }

  handleRadioButtonChange = e => {
    this.setState({ selectedRadioButton: e.currentTarget.value });
    this.props.handleExportParams(
      undefined,
      this.state.selectedDropdown,
      undefined,
    );
  };

  renderChart = () => {
    if (this.state.selectedRadioButton === 'Pie') {
      return (
        <PieChart
          chartTitle={this.state.selectedDropdown}
          alignTitle="middle"
          titleHorizontalAlign="center"
          chartColor={chartColor}
          dataLabelFormat="{point.value.asterisk}{point.percentage:.1f}%"
          donutSize="70%"
          dataLabelDistance={20}
          dataLabelColor="#30435d"
          titleColor="#30435d"
          data={{
            processedData: processData(
              {
                rawData: this.props.data[this.state.selectedDropdown],
              },
              this.updateAsteriskStatus,
              this.props.study,
            ),
            tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
          }}
          showLegend={false}
        />
      );
    }
    return (
      <BarChart
        chartColor={chartColor}
        dataLabelFormat="{point.value.asterisk}{y}"
        plotLines={[
          {
            color: '#30435d',
            value: 100,
            width: 2,
          },
        ]}
        dataLabelPosition={{ verticalAlign: 'top', y: -25 }}
        xAxisLabel={false}
        yAxisText="Index"
        dataLabels
        data={{
          processedData: processData(
            {
              rawData: this.props.data[this.state.selectedDropdown],
              y: 'index',
            },
            this.updateAsteriskStatus,
            this.props.study,
          ),
          tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
        }}
      />
    );
  };

  renderContent = () => {
    const segmentContent = getSegmentationContent(this.props.study);
    return segmentContent[this.state.selectedDropdown] &&
      segmentContent[this.state.selectedDropdown].map(
        ({ key, value }, index) => (
          <div key={uuid()} className="segmentation-chart-legends">
            <p className="margin-bottom-o">
              <button
                style={{
                  backgroundColor: chartColor[index],
                  width: '12px',
                  height: '12px',
                  borderRadius: '100%',
                }}
              />
              &nbsp;
            <b
                style={{
                  verticalAlign: 'middle',
                  marginLeft: '5px',
                  color: chartColor[index],
                }}
              >
                {key}
              </b>
            </p>
            <p>{value}</p>
          </div>
        ),
      );
  }

  renderDropdown = () => {
    const isMobWorldPresent = Object.keys(this.props.data)
      .some(item => item === MOBILE_WORLD);
    let filteredSegmentationDropdown = this.getDropdownValues(this.props.dropdown);
    if (!isMobWorldPresent) {
      filteredSegmentationDropdown = filteredSegmentationDropdown
        .filter(item => item.key !== MOBILE_WORLD);
    } else {
      filteredSegmentationDropdown = filteredSegmentationDropdown
        .filter(item => item.key !== MOBILITY_ADOPTION);
    }
    return filteredSegmentationDropdown.map(item => (
      <option value={item.dataKey} key={uuid()}>
        {item.key}
      </option>
    ));
  }

  render() {
    return (
      <div className="quick-report-graph-wrapper segmentation-qr-wrapper">
        <div className="large-12 text-center margin-top-10 margin-bottom-10">
          <div className="quick-report-dropdown display-inline">
            <select
              className="generic-select"
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdown}
            >
              {this.renderDropdown()}
            </select>
          </div>
          <div className="quick-report-radio display-inline float-left no-bg">
            <p>
              <input
                type="radio"
                id="pieType"
                name="ChartType"
                value="Pie"
                checked={this.state.selectedRadioButton === 'Pie'}
                onChange={this.handleRadioButtonChange}
              />
              <label htmlFor="pieType">
                <span>Pie</span>
              </label>
            </p>
            <p>
              <input
                type="radio"
                id="barType"
                name="ChartType"
                value="Bar"
                checked={this.state.selectedRadioButton === 'Bar'}
                onChange={this.handleRadioButtonChange}
              />
              <label htmlFor="barType">
                <span>Bar</span>
              </label>
            </p>
          </div>
        </div>
        <div className="column large-12">
          <div className="column medium-6 large-6">{this.renderChart()}</div>
          <div className="column medium-6 large-6">{this.renderContent()}</div>
        </div>
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

Segmentation.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({}),
};
